"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ToggleButton = require("../ToggleButton");
var _hooks = require("../hooks");
var _types = require("../types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var styles = {
  "operators-dropdown": "operators-dropdown_2_xEDi",
  "operatorsDropdown": "operators-dropdown_2_xEDi",
  "dropdown": "dropdown_35gvXP",
  "dropdown-header": "dropdown-header_i9LYPl",
  "dropdownHeader": "dropdown-header_i9LYPl",
  "dropdown-content": "dropdown-content_1RIjgL",
  "dropdownContent": "dropdown-content_1RIjgL",
  "dropdown-list": "dropdown-list_3tXbgZ",
  "dropdownList": "dropdown-list_3tXbgZ",
  "dropdown-list-item": "dropdown-list-item_CTA6fk",
  "dropdownListItem": "dropdown-list-item_CTA6fk",
  "clickable-list-item": "clickable-list-item_2DJRxJ",
  "clickableListItem": "clickable-list-item_2DJRxJ",
  "list-item-label": "list-item-label_d-_AyN",
  "listItemLabel": "list-item-label_d-_AyN",
  "list-item-description": "list-item-description_3-Y4bY",
  "listItemDescription": "list-item-description_3-Y4bY",
  "dropdown-footer": "dropdown-footer_EODv36",
  "dropdownFooter": "dropdown-footer_EODv36",
  "dropdown-footer-actions": "dropdown-footer-actions_1y-ErX",
  "dropdownFooterActions": "dropdown-footer-actions_1y-ErX",
  "symbol": "symbol_2Q4C9y"
}; 
require('./OperatorsDropdown.css');
const DROPDOWN_ID = 'custom-fields-operators-dropdown';
const OPERATIONS = {
  [_types.CustomFieldOperator.Equals]: {
    symbol: '=',
    label: 'equals'
  },
  [_types.CustomFieldOperator.NotEquals]: {
    symbol: '≠',
    label: 'not equal to'
  },
  [_types.CustomFieldOperator.GreaterThan]: {
    symbol: '>',
    label: 'greater than'
  },
  [_types.CustomFieldOperator.GreaterThanOrEqual]: {
    symbol: '≥',
    label: 'greater than or equal to'
  },
  [_types.CustomFieldOperator.LessThan]: {
    symbol: '<',
    label: 'less than'
  },
  [_types.CustomFieldOperator.LessThanOrEqual]: {
    symbol: '≤',
    label: 'less than or equal to'
  },
  [_types.CustomFieldOperator.Contains]: {
    symbol: '⊆',
    label: 'contains'
  },
  [_types.CustomFieldOperator.NotContains]: {
    symbol: '⊈',
    label: 'not contains'
  }
};
const OperatorsDropdown = ({
  options,
  onChange,
  value,
  defaultValue = _types.CustomFieldOperator.Equals
}) => {
  const [selectedOperator, setSelectedOperator] = (0, _react.useState)(value);
  const listRef = (0, _react.useRef)();
  const onKeyDown = (0, _hooks.useArrowHandling)(listRef, []);
  const {
    handleBlur,
    handleKeyDown,
    isExpanded,
    isFocused,
    closeDropdown,
    toggleDropdown
  } = (0, _hooks.useDropdown)();
  const selectOperator = (0, _react.useCallback)(operator => {
    setSelectedOperator(operator);
    closeDropdown();
    onChange(operator);
  }, [onChange, closeDropdown]);
  const onClickOption = operator => {
    selectOperator(operator);
  };
  const onKeyDownOption = (event, operator) => {
    if (['Enter', ' '].includes(event.key)) {
      selectOperator(operator);
    }
  };
  const currentOperator = options.includes(selectedOperator) ? selectedOperator : defaultValue;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react.default.createElement("div", {
      className: styles.operatorsDropdown,
      onKeyDown: handleKeyDown,
      onBlur: handleBlur
    }, /*#__PURE__*/_react.default.createElement(_ToggleButton.ToggleButton, {
      type: "secondary",
      label: OPERATIONS[currentOperator].symbol,
      active: !!currentOperator,
      expanded: isExpanded,
      controls: DROPDOWN_ID,
      isFocused: isFocused,
      onClick: toggleDropdown
    }), isExpanded && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.dropdown,
      "data-test-id": "custom-fields-operators-dropdown",
      id: DROPDOWN_ID,
      role: "listbox",
      tabIndex: -1
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.dropdownContent
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: styles.dropdownList,
      role: "listbox",
      "aria-label": "Operators dropdown",
      ref: listRef,
      tabIndex: 0,
      onKeyDown: onKeyDown
    }, options.map(operator => /*#__PURE__*/_react.default.createElement("li", {
      role: "option",
      "aria-selected": operator === selectedOperator,
      className: (0, _classnames.default)(styles.dropdownListItem, styles.clickableListItem),
      key: operator,
      onClick: () => onClickOption(operator),
      tabIndex: -1,
      onKeyDown: e => onKeyDownOption(e, operator)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.listItemLabel
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: styles.symbol
    }, OPERATIONS[operator].symbol, ' '), /*#__PURE__*/_react.default.createElement("span", {
      className: styles.listItemDescription
    }, "(", OPERATIONS[operator].label, ")"))))))))
  );
};
var _default = exports.default = OperatorsDropdown;
//# sourceMappingURL=OperatorsDropdown.js.map